import { toValue, type MaybeRefOrGetter } from "vue";

/**
 * This util is used to wait for the next event loop tick.
 *
 * It's useful to setup DOM listeners in the next event loop tick,
 * so that the listeners don't get triggered while setting them up,
 * which happens due to native event bubbling behavior.
 */
export async function nextEventLoopTick(cb?: () => void): Promise<void> {
  await new Promise<void>((resolve) => window.setTimeout(resolve, 0));
  if (cb) cb();
}

export function toValueReal<T>(value: MaybeRefOrGetter<T>): T {
  if (value instanceof Object && "value" in value) {
    return value.value as T;
  }

  return toValue(value);
}
